import { useTranslation } from 'react-i18next';
import { T } from '@/components/T';
import { Button, Tabs } from '@teo/components';
import { useGet } from '@/query';
import { newUid, useMobile } from '@/util';
import { useState, useContext, useEffect } from 'react';
import { AuthContext } from '@/components/Contexts/AuthContext';
import CompetencyProfiles from './CompetencyProfiles';
import AllCompetencies from './AllCompetencies';
import MobileSubPageMenu from '@/components/HeaderMobile/MobileSubPageMenu';
import { NavContext } from '@/components/NavContext';
import { useNavigate } from 'react-router-dom';
import { CategoryTab } from '@/components/Competencies/CategoryTab';

function ManageCompetenciesPage() {
  const { t } = useTranslation();
  const isMobile = useMobile();
  const [tab, setTab] = useState('allCompetencies');
  const { setSubPage } = useContext(NavContext);
  const { auth } = useContext(AuthContext);
  const navigate = useNavigate();
  const authUser = auth?.user;

  const [categories, setCategories] = useState([]);
  const [refetchTable, setRefetchTable] = useState<string>(newUid(20));

  const { refetch: refetchListCategories } = useGet(`/competencecategories`, {
    lang: auth?.user?.lang,
    organisationId: `${auth?.user?.activeOrganisationId},OR,organisationId=null`,
    sort: 'name',
    onSuccess: (result: any) => {
      setCategories(
        result?.data?.map((el: any) => ({
          id: el.id,
          name: el.name,
          color: el.colorCode,
        })) || null
      );
    },
  });

  useEffect(() => {
    setSubPage(true);
    return () => setSubPage(false);
  }, []);

  const competencyType = [
    {
      id: '1',
      name: t('pages.manage_competencies.type_knowledge'),
      label: 'knowledge',
    },
    {
      id: '2',
      name: t('pages.manage_competencies.type_attitude'),
      label: 'attitude',
    },
    {
      id: '3',
      name: t('pages.manage_competencies.type_skill'),
      label: 'skill',
    },
  ];

  return (
    <div className=" w-full max-w-6xl">
      {isMobile && (
        <MobileSubPageMenu title={t('pages.manage_competencies.title')} />
      )}
      <div className="flex items-center justify-between">
        {!isMobile && (
          <h1 className="my-8 text-xl font-semibold text-black">
            <T>{t('pages.manage_competencies.title')}</T>
          </h1>
        )}

        <div className="flex items-center gap-2">
          <Button
            onClick={() => navigate('import')}
            size="md"
            variant="outline"
          >
            {t('pages.manage_competencies.import.import_file')}
          </Button>
          <Button onClick={() => {}} size="md" className="hidden">
            {t('pages.manage_competencies.download_list_button')}
          </Button>
        </div>
      </div>

      <Tabs activeName={tab} onChange={(tab) => setTab(tab)}>
        <div className="flex flex-wrap gap-2">
          <Tabs.TabButton name="allCompetencies">
            <p className="text-base font-medium">
              {t('pages.manage_competencies.all_competencies_tab')}
            </p>
          </Tabs.TabButton>
          <Tabs.TabButton name="allCategory">
            <p className="text-base font-medium">
              {t('pages.manage_competencies.categories_tab')}
            </p>
          </Tabs.TabButton>
          <Tabs.TabButton name="competencyProfiles">
            <p className="text-base font-medium">
              {t('pages.manage_competencies.competency_profiles_tab')}
            </p>
          </Tabs.TabButton>
        </div>
      </Tabs>
      <div>
        {tab === 'allCompetencies' && (
          <AllCompetencies
            categories={categories}
            competencyType={competencyType}
            authUser={authUser}
          />
        )}
        {tab === 'allCategory' && (
          <CategoryTab
            authUser={authUser}
            setRefetchTable={setRefetchTable}
            refetchTable={refetchTable}
            refetchListCategories={refetchListCategories}
          />
        )}
        {tab === 'competencyProfiles' && (
          <CompetencyProfiles
            categories={categories}
            setRefetchTable={setRefetchTable}
            refetchTable={refetchTable}
          />
        )}
      </div>
      {/* {isOpenAdd && (
        <AddCompetencyProfilePage
          setIsOpenAdd={setIsOpenAdd}
          categories={categories}
          competencyType={competencyType}
          setRefetchProfile={setRefetchTable}
        />
      )}
      {isOpenEdit && activeProfile && (
        <EditCompetencyProfilePage
          setIsOpenEdit={setIsOpenEdit}
          setActiveProfile={setActiveProfile}
          activeProfile={activeProfile}
          categories={categories}
          competencyType={competencyType}
          setRefetchProfile={setRefetchTable}
        />
      )} */}
    </div>
  );
}

export default ManageCompetenciesPage;
